import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/jobs',
      name: 'jobs',
      component: () => import('./views/Jobs.vue')
    },
    {
      path: '/jobs/:id',
      name: 'detail',
      component: () => import('./views/Detail.vue')
    },
    {
      path: '/contact',
      name: 'contact',
      component: () => import('./views/Contact.vue')
    },
    {
      path: '/blogs',
      name: 'blogs',
      component: () => import('./views/Blogs.vue')
    },
    {
      path: '/blogs/:id',
      name: 'blog-detail',
      component: () => import('./views/BlogDetail.vue')
    },
    {
      path: '/my_applications',
      name: 'my_applications',
      component: () => import('./views/Applications.vue')
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    if(savedPosition) {
      return savedPosition;
    }
    if (to.hash) {
      return {
        // 這個是透過 to.hash 的值來找到對應的元素
        // 照你的 html 來看是不用多加處理這樣就可以了
        // 例如你按下 #3 的連結，就會變成 querySelector('#3')，自然會找到 id = 3 的元素
        selector: to.hash
      }
    }
    return {x: 0, y: 0}
  }
})
